import './OverlayModal.css';

import type { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const OverlayModalHeader: FC<Props> = (props) => (
  <div className='overlay-modal__header'>{props.children}</div>
);
